import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_5 = {
  ref: "dismissRef",
  class: "d-none",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      ref: "modalRef",
      class: "modal fade",
      tabindex: "-1",
      id: _ctx.id
    }, [
      _createVNode("div", {
        class: [
        'modal-dialog',
        _ctx.size ? `modal-${_ctx.size}` : '',
        { 'modal-dialog-scrollable': _ctx.scrollable }
      ]
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _hoisted_4
          ]),
          _renderSlot(_ctx.$slots, "default"),
          _createVNode("button", _hoisted_5, " HIDDEN BUTTON TO DISMISS ", 512)
        ])
      ], 2)
    ], 8, ["id"]),
    _createVNode("button", {
      ref: "showRef",
      class: "d-none",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_ctx.id}`
    }, " HIDDEN BUTTON TO OPEN ", 8, ["data-bs-target"])
  ], 64))
}